import React from "react";
import { withRouter } from "next/router";
import TrainingsAndHackthons from "./TrainingsAndHackthons";
import EngageAudience from "./EngageAudience";
import CollegeFestsAndCulturalEvents from "./CollegeFestsAndCulturalEvents";
import MeetupsAndWebinars from "./MeetupsAndWebinars";
import ConferencesAndSummits from "./ConferencesAndSummits";
import HomeNav from "../Home/HomeNav";
import HomeFooter from "../Home/HomeFooter";

const UseCases = () => {
  return (
    <>
      <HomeNav />
      <EngageAudience title={"EngageAudience"} />
      <ConferencesAndSummits title={"ConferencesAndSummits"} />
      <CollegeFestsAndCulturalEvents title={"CollegeFestsAndCulturalEvents"} />
      <MeetupsAndWebinars title={"MeetupsAndWebinars"} />
      <TrainingsAndHackthons title={"TrainingsAndHackthons"} />
      <HomeFooter />
    </>
  );
};

export default withRouter(UseCases);
